import React, { FC, useState, useCallback, useEffect } from 'react';
import { makeStyles, Container } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  navSpace: {
    marginTop: 32,
  },
}));

const UseCallbackSample: FC = () => {
  const classes = useStyles();
  const [time, setTime] = useState();
  const [count, setCount] = useState(0);

  const handleIncrementCount = () => {
    setCount(prevCount => prevCount + 1);
  };

  const inc = useCallback(handleIncrementCount, [setCount]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const currentTime = JSON.stringify(new Date(Date.now()));
      setTime(currentTime);
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [time]);

  return (
    <Container maxWidth="md" className={classes.navSpace}>
      <p>The current time is: {time}</p>
      <p>Count: {count}</p>
      <button type="button" onClick={inc}>
        +
      </button>
    </Container>
  );
};

export default UseCallbackSample;
